
function checkImagesLoaded() {
  const images = document.querySelectorAll('img.track-loaded');

  images.forEach((image) => {
    if (image.complete) {
      image.classList.add('is-complete');
    } else {
      image.addEventListener('load', () => {
        image.classList.add('is-complete');
      });
    }
  });
}

checkImagesLoaded();
document.addEventListener('shopify:section:load', (e) => {
  checkImagesLoaded();
});

document.addEventListener('switch:load:images', (e) => {
  checkImagesLoaded();
});

